// src/components/MyTasksWidget.jsx
import { useState, useEffect } from "react";
import * as api from "../apiService";

const PRIORITY_ORDER = { URGENT: 0, HIGH: 1, MEDIUM: 2, LOW: 3 };

const STATUS_CFG = {
  BACKLOG:     { label: "Backlog",     color: "#475569" },
  TO_DO:       { label: "To Do",       color: "#1d4ed8" },
  IN_PROGRESS: { label: "In Progress", color: "#92400e" },
  REVIEW:      { label: "Review",      color: "#5b21b6" },
  DONE:        { label: "Done",        color: "#065f46" },
};

const PRIORITY_CFG = {
  URGENT: { color: "#dc2626" },
  HIGH:   { color: "#d97706" },
  MEDIUM: { color: "#2563eb" },
  LOW:    { color: "#64748b" },
};

export function MyTasksWidget({ setPage }) {
  const [tasks,   setTasks]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.fetchTasks()
      .then(setTasks)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const open = tasks.filter(t => t.status !== "DONE");
  const urgent = [...open]
    .sort((a, b) => {
      const pd = (PRIORITY_ORDER[a.priority] ?? 2) - (PRIORITY_ORDER[b.priority] ?? 2);
      if (pd !== 0) return pd;
      if (a.dueDate && b.dueDate) return a.dueDate.localeCompare(b.dueDate);
      if (a.dueDate) return -1;
      if (b.dueDate) return  1;
      return 0;
    })
    .slice(0, 4);

  if (loading) return null;
  if (tasks.length === 0) return null;

  return (
    <div style={{
      background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10,
      padding: "16px 20px", marginBottom: 20, maxWidth: 680,
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div>
          <span style={{ fontWeight: 700, fontSize: 15, color: "#111827" }}>My Tasks</span>
          <span style={{ marginLeft: 10, fontSize: 12, color: "#6b7280" }}>
            {open.length} open
            {tasks.filter(t => t.status === "DONE").length > 0
              ? ` · ${tasks.filter(t => t.status === "DONE").length} done`
              : ""}
          </span>
        </div>
        <button className="btn" onClick={() => setPage("tasks")}
          style={{ fontSize: 12, padding: "3px 12px" }}>
          View All →
        </button>
      </div>

      {urgent.length === 0 ? (
        <div style={{ fontSize: 13, color: "#6b7280" }}>All tasks completed. Great work!</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {urgent.map(t => {
            const pc  = PRIORITY_CFG[t.priority]  ?? PRIORITY_CFG.MEDIUM;
            const sc  = STATUS_CFG[t.status]       ?? STATUS_CFG.BACKLOG;
            const due = t.dueDate && new Date(t.dueDate) < new Date();
            return (
              <div key={t.id}
                onClick={() => setPage("tasks")}
                style={{
                  display: "flex", alignItems: "center", gap: 10,
                  padding: "7px 10px", borderRadius: 6,
                  background: "#f8fafc", border: "1px solid #e2e8f0",
                  cursor: "pointer",
                }}>
                <span style={{ width: 6, height: 6, borderRadius: "50%",
                  background: pc.color, flexShrink: 0 }} />
                <span style={{ flex: 1, fontSize: 13, fontWeight: 500, color: "#1f2937",
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {t.title}
                </span>
                {t.dueDate && (
                  <span style={{ fontSize: 11, color: due ? "#dc2626" : "#6b7280",
                    fontWeight: due ? 600 : 400, whiteSpace: "nowrap" }}>
                    {due ? "Overdue" : t.dueDate}
                  </span>
                )}
                <span style={{ fontSize: 11, color: sc.color, whiteSpace: "nowrap" }}>
                  {sc.label}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
